<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar v-if="navType === 'side' && !isDashboard" class="sidebar-container"></sidebar>
    <div class="main-container" :class="{ 'full-width': navType === 'top' || isDashboard }">
      <navbar v-if="!isDashboard"></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, InfoToggle } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    InfoToggle
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    navType() {
      return this.$store.state.app.navType
    },
    isDashboard() {
      return this.$route.path === '/dashboard'
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: auto;
  }
  
  /* 顶部导航模式样式 */
  .main-container {
    transition: all 0.2s ease;
    min-height: 100vh;
  }
  
  .main-container.full-width {
    width: 100% !important;
    margin-left: 0 !important;
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue